module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/home/sections/social_proof/assets/avatars-4a7b332facd0b95f2218077fbf293f78.png";